import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "../common/ScrollToTop";
import SmoothScroll from "../common/SmoothScroll";

export default function Layout() {
  return (
    <div className="App kv-grain min-h-screen bg-kv-bg text-kv-off">
      <SmoothScroll />
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
